import { h } from '@stencil/core';
import toast from 'store/toast';

const iconType = {
  success: 'checkmark-circle-filled',
  error: 'error-circle-filled',
  warning: 'warning-filled',
  info: 'info-circle-filled',
};

export default function Toast({ show }: { show: boolean }) {
  const hasTitle = typeof toast.title !== 'undefined';
  const hasText = typeof toast.text !== 'undefined';
  const icon = iconType[toast.type];

  return show ? (
    <div
      class={`toast eva-3-message eva-3-message--toast -eva-3-shadow-static -${toast.type} ${!hasTitle ? '-no-title' : ''} ${!hasText ? '-no-content' : ''} ${toast.loader ? '-loading' : ''} ${toast.verticalPosition} ${toast.horizontalPosition}`}
    >
      <i class="eva-3-icon-cross message-close" onClick={() => (toast.isOpen = false)} />
      <div class="message-icon-container">
        <i class={`eva-3-icon-${icon} message-icon`} />
      </div>
      {hasTitle && (
        <div class="message-header">
          <h5 class="eva-3-h5 message-title">{toast.title}</h5>
        </div>
      )}
      {hasText && (
        <div class="message-body">
          <div class="eva-3-body-2 message-text">{toast.text}</div>
        </div>
      )}
      {toast.loader && <span class="message-loader"></span>}
    </div>
  ) : null;
}
